import type { TransactionItemDetail } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscriptionPlans } from '../../hooks';

type P = {
  transactionItem: TransactionItemDetail;
};

export const useGetTransactionItemDate = ({ transactionItem }: P) => {
  const { t } = useTranslation();
  const { getTranslate } = useSubscriptionPlans();

  return useMemo(
    () =>
      transactionItem.chargeType !== 'one_time' && transactionItem.transaction?.subscription
        ? t('{{recurringOption}} donor since {{startDate}}', {
            recurringOption: getTranslate(transactionItem.chargeType),
            startDate: t('dateFormats.shortMonthDayYear', { date: transactionItem.transaction.subscription.createdAt }),
          })
        : t('paymentAge', {
            date: transactionItem.createdAt,
          }),
    [getTranslate, t, transactionItem.chargeType, transactionItem.createdAt, transactionItem.transaction?.subscription],
  );
};
